import React from "react";
import {AuditLogTime} from "./DemoGraphState";

// black line above description
// off white backgroud

// Draw either a folder icon or a document icon depending on the boolean folder.
//
// displayAs determines how to highlight the icon (past, current, future)..
export function DocumentIcon({x, y, height, width, center, displayAs, folder, docClick, id}: {
    x: number,
    y: number,
    height: number,
    width: number,
    center: boolean
    displayAs: AuditLogTime,
    folder: boolean,
    docClick: (e: React.MouseEvent) => void,
    id: string,
}) {
    if (center) {
        x -= width / 2;
        y -= height / 2;
    }
    // // TODO: How to we overwrite the class?
    // let icon = folder ? folderIcon : documentIcon;
    // return (<image href={icon} id={id} onClickCapture={docClick} className={`document-icon ${displayAs}-icon`} x={x} y={y} height={height} width={width}/>);

    let icon;
    if (folder) {
        icon= <>
            <path d="M1.60175 4.20114C2.14997 3.47258 3.02158 3 4 3H20C20.9784 3 21.85 3.47258 22.3982 4.20113L12 11.7635L1.60175 4.20114Z"/>
            <path d="M1 6.2365V18C1 19.6523 2.34772 21 4 21H20C21.6523 21 23 19.6523 23 18V6.23649L13.1763 13.381C12.475 13.891 11.525 13.891 10.8237 13.381L1 6.2365Z"/>
        </>
    } else {
        icon = <>
            <path opacity="0.15" d="M5 21H19V9H15C13.8954 9 13 8.10457 13 7V3H5V21Z"/>
            <path d="M8 13H14M8 17H16M13 3H5V21H19V9M13 3H14L19 8V9M13 3V7C13 8 14 9 15 9H19" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </>;
    }
    const viewBox = "0 0 24 24";

    return (<svg id={id} onClickCapture={docClick} className={`document-icon ${displayAs}-icon`} x={x} y={y} height={height} width={width} viewBox={viewBox}>
        {icon}
    </svg>);
}

export function LedgerIcon({x, y, height, width}: {x: number, y: number, height: number, width: number}) {
    // From: svgrepo.com : Home / Solar Bold Icons / Document (1)
    // License: https://www.svgrepo.com/page/licensing#CC%20Attribution
    return (<svg className="ledger-grid" x={x} y={y} height={height} width={width} viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H5C4.44772 6 4 5.55228 4 5ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12ZM7.25 15.5C7.25 15.0858 7.58579 14.75 8 14.75H13.5C13.9142 14.75 14.25 15.0858 14.25 15.5C14.25 15.9142 13.9142 16.25 13.5 16.25H8C7.58579 16.25 7.25 15.9142 7.25 15.5Z"/>
        <path d="M4.40879 4.0871C4.75727 4.24338 5 4.59334 5 5H17C17.3453 5 17.6804 5.04375 18 5.12602V4.30604C18 3.08894 16.922 2.15402 15.7172 2.32614L4.91959 3.86865C4.72712 3.89615 4.55271 3.97374 4.40879 4.0871Z"/>
    </svg>);
}

export function SignedIcon({x, y, height, width}: {x: number, y: number, height: number, width: number}) {
    // From: svgrepo.com : Home / Untitled UI Oval Interface Icons / Award 03
    // License: https://www.svgrepo.com/page/licensing#CC%20Attribution
    return (<svg className="ledger-grid" x={x} y={y} height={height} width={width} viewBox="0 0 24 24">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
        <path d="M7.86866 15.4599L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.1319 15.4571M16.4259 4.24888C16.5803 4.6224 16.8768 4.9193 17.25 5.0743L18.5589 5.61648C18.9325 5.77121 19.2292 6.06799 19.384 6.44154C19.5387 6.81509 19.5387 7.23481 19.384 7.60836L18.8422 8.91635C18.6874 9.29007 18.6872 9.71021 18.8427 10.0837L19.3835 11.3913C19.4602 11.5764 19.4997 11.7747 19.4997 11.975C19.4998 12.1752 19.4603 12.3736 19.3837 12.5586C19.3071 12.7436 19.1947 12.9118 19.0531 13.0534C18.9114 13.195 18.7433 13.3073 18.5582 13.3839L17.2503 13.9256C16.8768 14.0801 16.5799 14.3765 16.4249 14.7498L15.8827 16.0588C15.728 16.4323 15.4312 16.7291 15.0577 16.8838C14.6841 17.0386 14.2644 17.0386 13.8909 16.8838L12.583 16.342C12.2094 16.1877 11.7899 16.188 11.4166 16.3429L10.1077 16.8843C9.73434 17.0387 9.31501 17.0386 8.94178 16.884C8.56854 16.7293 8.27194 16.4329 8.11711 16.0598L7.57479 14.7504C7.42035 14.3769 7.12391 14.08 6.75064 13.925L5.44175 13.3828C5.06838 13.2282 4.77169 12.9316 4.61691 12.5582C4.46213 12.1849 4.46192 11.7654 4.61633 11.3919L5.1581 10.0839C5.31244 9.71035 5.31213 9.29079 5.15722 8.91746L4.61623 7.60759C4.53953 7.42257 4.50003 7.22426 4.5 7.02397C4.49997 6.82369 4.5394 6.62536 4.61604 6.44032C4.69268 6.25529 4.80504 6.08716 4.94668 5.94556C5.08832 5.80396 5.25647 5.69166 5.44152 5.61508L6.74947 5.07329C7.12265 4.91898 7.41936 4.6229 7.57448 4.25004L8.11664 2.94111C8.27136 2.56756 8.56813 2.27078 8.94167 2.11605C9.3152 1.96132 9.7349 1.96132 10.1084 2.11605L11.4164 2.65784C11.7899 2.81218 12.2095 2.81187 12.5828 2.65696L13.8922 2.11689C14.2657 1.96224 14.6853 1.96228 15.0588 2.11697C15.4322 2.27167 15.729 2.56837 15.8837 2.94182L16.426 4.25115L16.4259 4.24888Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
    </svg>);
}

